import React, { useEffect, useState, useRef } from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
import { filterBy } from "@progress/kendo-data-query";
import {
  getDdCountryData,
  getDdOPSSegmentData,
  getDdRegionData,
  getDdSCACData,
  getTransportationModeData,
} from "./CarrierContactService";
import "./CarrierContact.scss";

function CarrierContact({ onSearchClick, ddData, setDdData }) {
  const [ddRegion, setDdRegion] = useState(null);
  let allCountries = useRef([]);
  const initCountries = [{ countryName: "ZZ", countryCode: "" }];
  const [ddCountry, setDdCountry] = useState(initCountries);
  const [ddSCAC, setDdSCAC] = useState(null);
  const [ddOPSSegment, setDdOPSSegment] = useState(null);

  const ddDefaultItems = {
    region: { geo: "Select Region...", value: "Select region" },
    country: {
      countryName: "Select Country...",
      countryCode: "Select country",
    },
    scac: { text: "Select SCAC...", value: "Select SCAC" },
    opssegment: { opsGrp: "Select OPS Segment..." },
  };

  const [ddDefaultValues, setddDefaultValues] = useState({
    region: { geo: "ZZ", value: "" },
    country: { countryName: "ZZ", countryCode: "" },
    scac: { text: "ZZ", value: "" },
    opssegment: { opsGrp: "ZZ" },
  });

  useEffect(() => {
    const getDdData = async () => {
      let isCancelled = false;
      // console.log(await getDdOPSSegmentData());
      // console.log(await getDdCountryData());
      // console.log(await getDdSCACData());
      let response1 = [...(await getDdOPSSegmentData()), { opsGrp: "ZZ" }];
      let response2 = [
        ...(await getDdCountryData()),
        { geo: "ZZ", country: "ZZ", countryCode: "ZZ", countryName: "ZZ" },
      ];
      let response3 = await getDdSCACData();
      
      let response4 = [...getDdRegionData(response2)];
      let response5 = [
        ...(await getTransportationModeData()),
        { value: "", text: "ZZ" },
      ];
      if (!isCancelled) {
        setDdOPSSegment(response1);
        allCountries.current = response2;
        setDdSCAC(response3);
        setDdRegion(response4);
        setDdData({
          region: response4,
          country: initCountries,
          scac: response3,
          opssegment: response1,
          allCountries: response2,
          transportationMode: response5,
        });
        onSearchClick([{ opsGrp: "", geo: "", carrier: "", country: "" }]);
      }
      return () => {
        isCancelled = true;
      };
    };
    getDdData();
  }, []);

  const ddRegionFilterChange = (event) => {
    setDdRegion(ddRegionFilterData(event.filter));
  };

  const ddRegionFilterData = (filter) => {
    const data = ddData["region"].slice();
    return filterBy(data, filter);
  };

  const ddCountryFilterChange = (event) => {
    setDdCountry(ddCountryFilterData(event.filter));
  };

  const ddCountryFilterData = (filter) => {
    const data = ddData["country"].slice();
    return filterBy(data, filter);
  };

  const ddSCACFilterChange = (event) => {
    setDdSCAC(ddSCACFilterData(event.filter));
  };

  const ddSCACFilterData = (filter) => {
    const data = ddData["scac"].slice();
    console.log(data)
    return filterBy(data, filter);
  };

  const ddOPSSegmentFilterChange = (event) => {
    setDdOPSSegment(ddOPSSegmentFilterData(event.filter));
  };

  const ddOPSSegmentFilterData = (filter) => {
    const data = ddData["opssegment"].slice();
    return filterBy(data, filter);
  };

  const ddRegionValueChange = (event) => {
    const filteredCountries = allCountries.current.filter(
      (country) => country["geo"] === event.target.value["geo"]
    );
    setddDefaultValues({ ...ddDefaultValues, region: event.target.value });
    setDdCountry(filteredCountries);
    setDdData({ ...ddData, country: filteredCountries });
  };

  const ddCountryValueChange = (event) => {
    setddDefaultValues({ ...ddDefaultValues, country: event.target.value });
  };

  const ddSCACValueChange = (event) => {
    setddDefaultValues({ ...ddDefaultValues, scac: event.target.value });
  };

  const ddOPSSegmentValueChange = (event) => {
    setddDefaultValues({ ...ddDefaultValues, opssegment: event.target.value });
  };

  const handleSearchClick = () => {
    const refinedDDValues = [
      {
        opsGrp: ddDefaultValues["opssegment"]["opsGrp"],
        geo: ddDefaultValues["region"]["geo"],
        carrier: ddDefaultValues["scac"]["text"],
        country: ddDefaultValues["country"]["countryCode"],
      },
    ];

    onSearchClick(refinedDDValues);
  };

  return (
    <>
      {ddCountry && ddSCAC && ddOPSSegment && ddRegion ? (
        <MDBContainer fluid className="box-container carrier-contact">
          <MDBRow className="rowBtm">
            {/* Region */}
            <MDBCol md="2" className="col-label">
              <label>Region</label>
            </MDBCol>
            <MDBCol md="3">
              <DropDownList
                style={{ width: "100%" }}
                dataItemKey="value"
                textField="geo"
                filterable={true}
                data={ddRegion}
                onFilterChange={ddRegionFilterChange}
                defaultItem={ddDefaultItems["region"]}
                value={ddDefaultValues["region"]}
                onChange={ddRegionValueChange}
              ></DropDownList>
              {/*filter={this.ClearParent}*/}
            </MDBCol>
            <MDBCol md="1"></MDBCol>

            {/* Country */}
            <MDBCol md="2" className="col-label">
              <label>Country</label>
            </MDBCol>
            <MDBCol md="3">
              <DropDownList
                style={{ width: "100%" }}
                dataItemKey="countryCode"
                textField="countryName"
                filterable={true}
                data={ddCountry}
                onFilterChange={ddCountryFilterChange}
                defaultItem={ddDefaultItems["country"]}
                value={ddDefaultValues["country"]}
                onChange={ddCountryValueChange}
              ></DropDownList>
            </MDBCol>
          </MDBRow>

          <MDBRow className="rowBtm">
            {/* scac */}
            <MDBCol md="2" className="col-label">
              <label>SCAC</label>
            </MDBCol>
            <MDBCol md="3">
              <DropDownList
                style={{ width: "100%" }}
                dataItemKey="value"
                textField="text"
                filterable={true}
                data={ddSCAC}
                onFilterChange={ddSCACFilterChange}
                defaultItem={ddDefaultItems["scac"]}
                value={ddDefaultValues["scac"]}
                onChange={ddSCACValueChange}
              ></DropDownList>
            </MDBCol>
            <MDBCol md="1"></MDBCol>

            {/* OPS Segment */}
            <MDBCol md="2" className="col-label">
              <label><b>OPS Segment</b></label>
            </MDBCol>
            <MDBCol md="3">
              <DropDownList
                style={{ width: "100%" }}
                dataItemKey="opsGrp"
                textField="opsGrp"
                filterable={true}
                data={ddOPSSegment}
                onFilterChange={ddOPSSegmentFilterChange}
                defaultItem={ddDefaultItems["opssegment"]}
                value={ddDefaultValues["opssegment"]}
                onChange={ddOPSSegmentValueChange}
              ></DropDownList>
            </MDBCol>
          </MDBRow>
          <MDBRow className="dropdownSubmitRow">
            <Button
              primary={true}
              className="dropdownSubmit"
              onClick={handleSearchClick}
            >
              Search
            </Button>
          </MDBRow>
        </MDBContainer>
      ) : (
        <span>"Loading ... "</span>
      )}
      {/* <div>
        <pre>{JSON.stringify(ddDefaultValues, null, 2)}</pre>
      </div> */}
    </>
  );
}

export default CarrierContact;
